import { AssemblyPartsComponent, ModelInfoComponent, ProductStructureComponent } from '@inter-ikea-core/core'

import { useCoreStore } from '../core-store'

/**
 * HTTP prefetch model data for the product and its parts (if any)
 */
export function httpPrefetchModelData(id: string) {
  if (import.meta.env.SSR) return
  const core = useCoreStore.getState().core
  if (!core) return // Core not initialized yet
  const productSpecification = core.coreServices.productManager.productSpecification(id)
  const assemblyParts = productSpecification?.findComponent<AssemblyPartsComponent>(AssemblyPartsComponent.id)
  const productStructure = productSpecification?.findComponent<ProductStructureComponent>(ProductStructureComponent.id)
  /**
   * Non assembly product - fetch its model directly and return
   */
  if (!assemblyParts && !productStructure) {
    const modelInfo = productSpecification?.findComponent<ModelInfoComponent>(ModelInfoComponent.id)

    if (modelInfo?.modelUrl) {
      void fetch(modelInfo.modelUrl)
    }
    return
  }
  /**
   * Assembly/Product Structure product - fetch all its parts models
   */
  const parts = productStructure?.products ?? assemblyParts?.asArray()
  const modelParts = parts
    ?.map((part) => {
      const productSpecification = core.coreServices.productManager.productSpecification(part.productRef)
      return productSpecification?.findComponent<ModelInfoComponent>(ModelInfoComponent.id)?.modelUrl
    })
    .filter(Boolean)

  modelParts?.forEach((modelUrl) => void fetch(modelUrl))
}
